import { fontsConfig, Themes } from '@repo/fonts/config';
import { createGlobalStyle } from 'styled-components';

const GlobalFonts = createGlobalStyle<{
    themeName: Themes;
    shouldExcludeFont?: boolean;
}>`
  ${({ themeName, shouldExcludeFont }) => {
      const themeFonts = getThemeFonts(themeName);
      if (!themeFonts) return '';

      const fontFaces = themeFonts.fonts
          .map((font) => {
              const src = `url('${font.url}') format('woff2')`;

              return `
      @font-face {
        font-family: '${font.family}';
        src: ${src};
        font-weight: ${font.weight}
        font-style: normal;
        font-display: swap;
      }
    `;
          })
          .join('');

      return `
      ${fontFaces}

    

 ${
     shouldExcludeFont
         ? ''
         : `
      html {
        font-size: 16px;
      }

    body, button {
      font-family: '${themeFonts.mainFontFamily}', sans-serif;
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
  `
 }
        
    `;
  }}
`;

export function getThemeFonts(themeName: Themes) {
    return fontsConfig.find((config) => config.themeName === themeName);
}

export function getFontFamily(themeName: Themes) {
    const fonts = getThemeFonts(themeName);
    return fonts?.mainFontFamily ?? 'sans-serif';
}

export default GlobalFonts;
